import React from "react";

const LocationInfoCard = ({ locationInfo }) => {
  return (
    <div className="location-card card_background">
      <h3 className="section-titleeee">Detalles de la sede</h3>

      <div className="detail-item">
        <span className="detail-label">Modalidad:</span>
        <span className="detail-value">Presencial</span>
      </div>
      <div className="detail-item">
        <span className="detail-label">Sede:</span>
        <span className="detail-value">{locationInfo.nombre ? locationInfo.nombre : 'S/D'}</span>
      </div>
      <div className="detail-item">
        <span className="detail-label">Ciudad:</span>
        <span className="detail-value">{locationInfo.city ? locationInfo.city : 'S/D'}</span>
      </div>

      <div className="detail-item">
        <span className="detail-label">Dirección:</span>
        <span className="detail-value">{locationInfo.Direcion ? locationInfo.Direcion : 'S/D'}</span>
      </div>

      <div className="detail-item">
        <span className="detail-label">Teléfono:</span>
        <span className="detail-value">{locationInfo.telefono ? locationInfo.telefono : 'S/D'}</span>
      </div>
      <div className="detail-item">
        <span className="detail-label">Email: </span>
        <span className="detail-value"> {locationInfo.email ? locationInfo.email : 'S/D'}</span>
      </div>
    </div>
  );
};

export default LocationInfoCard;
